import { setSpecificMessage, minGraphemes } from "valibot";
setSpecificMessage(
  minGraphemes,
  (issue) => `Graphèmes invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);